module.exports = __webpack_public_path__ + "static/media/spinner_color.503ca60b.gif";